import styled from "styled-components";
import { Link } from "react-router-dom";
import { Navbar } from "react-bootstrap";

export const StyledLink = styled(Link)`
  text-decoration: none;
  text-transform: capitalize;

  i {
    transform: scale(1.5);
  }
`;

export const StyledNavbar = styled(Navbar)`
  border-style: none;
  background: ${(props) => (props.dark ? "var(--primary-dark)" : "var(--primary-light)")};

  .navbar-brand {
    font-family: Roboto;
    font-size: 2em;
    font-weight: bold;
    color: ${(props) => (props.dark ? "var(--text-primary-dark)" : "var(--text-primary-light)")};
  }

  .navbar-brand img {
    height: 2.2rem;
  }

  .nav-item {
    max-width: 8rem;
  }

  .nav-item,
  .dropdown-toggle {
    color: ${(props) => (props.dark ? "var(--text-primary-dark)" : "var(--text-primary-light)")} !important;
    cursor: pointer;
  }

  .nav-link.active {
    padding-bottom: 0;
    border-bottom: 4px solid #5eb2f2;
  }
`;
